import ApplicationAdapter from './application';

export default class SignInFieldActionsContactAdapter extends ApplicationAdapter {
  pathForType() {
    return 'sign-in-field-actions-contacts';
  }
}
